import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import partyEventsReducer from '../features/partyEvents/partyEventsSlice';
import currentPartyEventReducer from '../features/currentPartyEvent/currentPartyEventSlice'
import currentEventTaskReducer from '../features/currentEventTask/currentEventTaskSlice'
import currentEventUsersReducer from '../features/currentEventUsers/currentEventUsersSlice'
import invitationReducer from '../features/invitation/invitationSlice'
import menuReducer from '../features/menu/menuSlice'
import currentEventUserReducer from '../features/addEventUser/currentEventUserSlice'
import messageBoxReducer from '../features/messageBoxes/messageBoxSlice'
import currentAttendeeReducer from '../features/currentAttendee/currentAttendeeSlice'
import notificationReducers from '../features/notifications/notificationsSlice'
import { loadState } from '../utils/browserStorage';
import currentFeedbackReducer from '../features/feedback/feedBackSlice'


export const store = configureStore({
  reducer: {
    counter: counterReducer,
    partyEvents: partyEventsReducer,
    currentPartyEvent: currentPartyEventReducer,
    currentEventTask: currentEventTaskReducer,
    menu: menuReducer,
    currentEventUsers: currentEventUsersReducer,
    currentEventUser: currentEventUserReducer,
    invitation: invitationReducer,
    messageBox: messageBoxReducer,
    currentAttendee : currentAttendeeReducer,
    notification : notificationReducers,
    currentFeedback : currentFeedbackReducer
    
  },
  preloadedState: {
    invitation : loadState('invitation')
  }
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
